import { TableBody } from "@/components/ui/table";
import { TableSkeletonRow } from "./Rows/TableSkeletonRow";
import { Spinner, SpinnerText } from "@/components/Spinner";

export const LoadingTableBody = ({
	allColumns,
	pageSize,
	spinnerText,
}: {
	allColumns: any[];
	pageSize: number;
	spinnerText?: SpinnerText;
}) => {
	return (
		<TableBody className="relative">
			{Array.from({ length: pageSize }).map((_, i) => (
				<TableSkeletonRow key={i} allColumns={allColumns} rowIndex={i} />
			))}

			{spinnerText && (
				<tr className="pointer-events-none">
					<td colSpan={allColumns.length} className="p-0">
						<div className="absolute inset-0 flex items-center justify-center z-10 bg-transparent backdrop-blur-sm">
							<Spinner messages={spinnerText} size={42} intervalMs={5000} />
						</div>
					</td>
				</tr>
			)}
		</TableBody>
	);
};
